import {useSearchParams} from "react-router-dom";
import {Card, Col, Row, Grid} from "antd";
import {MySegmented, MyText} from "../../components";
import {useLayoutEffect} from "react";
import { ScrollableCol } from "./style";
import { useTranslation } from "react-i18next";
export const SpecialistsPage = () => {
  const {t} = useTranslation("common")
  const [searchParams, setSearchParams] = useSearchParams();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const segmentedParams: any = searchParams.get('type')

  const SPECIALIST_TYPE = [
    {
      key: 'speech_therapist',
      title: t("SpeechTherapist")
    },
    {
      key: 'defectologist',
      title: t("Defectologist")
    },
    {
      key: 'psychologist',
      title: t("Psychologist")
    },
    {
      key: 'educator',
      title: t("Educator")
    }
  ]

  const title = SPECIALIST_TYPE.find(item => item.key === segmentedParams)?.title

  useLayoutEffect(() => {
    if (!segmentedParams) {
      handleChangeSegmented(SPECIALIST_TYPE[0].key)
    }
  }, []);


  const handleChangeSegmented = (value: any) => {
    setSearchParams({
      type: value
    })
  }

  return (
    <Row justify='center'>
      <Col span={20}>
        <Row gutter={[screens.xs ? 0 : 24, 24]}>
          <Col span={24}>
            <MyText color='#0A033C' size={32} weight={800}
                    style={{fontFamily: 'Nunito', display: 'block', textAlign: 'center'}}>
              {title}
            </MyText>
          </Col>
          <ScrollableCol span={24} style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
            <MySegmented
              type='primary'
              options={SPECIALIST_TYPE.map(item => ({
                label: item.title,
                value: item.key
              }))}
              onChange={handleChangeSegmented}
              value={segmentedParams}
            />
          </ScrollableCol>

          <Col span={24}>
            <Card>

            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}